import React from "react";

export default function AdminSubscriptions() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">Assinaturas</h1>
        <p className="text-zinc-400 mt-1">Gerencie assinaturas e trials</p>
      </div>
      <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8 text-center">
        <p className="text-zinc-400">Em desenvolvimento - Fase 2</p>
        <p className="text-sm text-zinc-500 mt-2">
          Aqui você poderá gerenciar assinaturas, trials, pagamentos e renovações
        </p>
      </div>
    </div>
  );
}
